import { render, staticRenderFns } from "./Biographie.vue?vue&type=template&id=3783a543&"
import script from "./Biographie.vue?vue&type=script&lang=js&"
export * from "./Biographie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports